import { api } from '../api/client';
import { API_ADMIN_DOCS_URL } from '../utils';

/**
 * The admin half of the documentation portal, served by the API behind
 * assertAdmin rather than as static files — a static host cannot tell an
 * admin from anyone else, so "hidden tab" was the only protection the first
 * build had. Admin-only is enforced by the API, not by these calls.
 *
 * Everything here ships with the API deploy (keepr-api docs/portal/, written
 * by this repo's `npm run build:docs`), so it is as current as the last API
 * deploy, not the last web deploy.
 */

/** changelog | changelog-files | loc | atlases | guides | guides-body */
export async function getAdminDocsResource(name) {
	const { data } = await api.get(`${API_ADMIN_DOCS_URL}/${encodeURIComponent(name)}`);
	return data;
}

/**
 * What this API deploy can serve, and the commit it is running:
 * { resources: [...], atlases: [...], running: { commit, ancestry, version, since } }.
 * `running.commit` is null when the host has no git to ask.
 */
export async function getAdminDocsIndex() {
	const { data } = await api.get(API_ADMIN_DOCS_URL);
	return data;
}

/** One atlas page, as an HTML string for a sandboxed frame's srcDoc. */
export async function getAtlasHtml(key) {
	const { data } = await api.get(`${API_ADMIN_DOCS_URL}/atlases/${encodeURIComponent(key)}`, {
		responseType: 'text',
		// Without this axios would try to JSON.parse a page that happens to
		// start with a brace; it is markup, and it stays a string.
		transformResponse: [body => body],
	});
	return data;
}
